import React, { useState, useEffect } from "react";
import {
  Container,
  AppBar,
  responsiveFontSizes,
  Typography,
  Grow,
  Grid,
  MuiThemeProvider,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { getPosts } from "./actions/posts";
import Posts from "./components/Posts/Posts";
import Form from "./components/Form/Form";
import { createTheme } from "@material-ui/core";
//import repository from "./image/icons8-favorite-folder-30.png";
import useStyles from "./styles";

let theme = createTheme();
theme = responsiveFontSizes(theme);

const App = () => {
  const [currentId, setCurrentId] = useState(null);
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  return (
    <Container
      className={classes.Container}
      maxwidth="lg"
      sx={{ overflow: "hidden" }}
    >
      <AppBar className={classes.appBar} position="static" color="inherit">
        <MuiThemeProvider theme={theme}>
          <Typography className={classes.heading} variant="h2" align="center">
            Paalala
          </Typography>
          <Typography className={classes.heading6} variant="h6" align="center">
            Shared_Affirmations
          </Typography>
        </MuiThemeProvider>

        {/*   <img
          className={classes.image}
          src={repository}
          alt="icon"
          height="60"
        /> */}
      </AppBar>
      <Grow in>
        <Container>
          <Grid
            className={classes.mainContainer}
            container
            justifyContent="space-between"
            alignitems="stretch"
            spacing={3}
          >
            <Grid item xs={12} sm={7}>
              <Posts setCurrentId={setCurrentId} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Form currentId={currentId} setCurrentId={setCurrentId} />
            </Grid>
          </Grid>
        </Container>
      </Grow>
      <div className={classes.footer}>
        <Typography className={classes.heading5} variant="h3" align="center">
          <text>© 2022 | Redjyll Brint I. Ondo</text>
        </Typography>
        <Typography className={classes.heading5} variant="h3" align="center">
          <text></text>
        </Typography>
      </div>
    </Container>
  );
};

export default App;
